export default function (colorString, alpha) {
  return (
    colorString &&
    `color-mix(in srgb, ${colorString} ${100 * alpha}%, transparent)`
  );
}
